import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2768499a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "tip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spin = _resolveComponent("Spin")!

  return _withDirectives((_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["full-loading", { absolute: _ctx.absolute }]),
    style: _normalizeStyle(_ctx.getStyle),
    onClick: _withModifiers(() => {}, ["stop"])
  }, [
    _createVNode(_component_Spin, _mergeProps(_ctx.$attrs, {
      size: _ctx.size,
      spinning: _ctx.loading
    }), null, 16, ["size", "spinning"]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.tip || '数据加载中'), 1)
  ], 14, _hoisted_1)), [
    [_vShow, _ctx.loading]
  ])
}